import { ESTADO_STOCK } from "../common/Constants";

export default {
  data: {
    data: {
      basicInfoSchema: {
        logistica: {
          _name: 'Logística',
          reception_date: {
            name: 'Fecha de recepción',
            required: false,
            type: 'date',
            dateTo: {
              until: "TODAY"
            },
            disabledByState: {
              Facturado: true,
            },
          },
          antiquity_days: {
            name: 'Días de antigüedad',
            required: false,
            disabled: true,
            type: 'number',
            disabledByState: {
              Facturado: true,
            },
          },
          branch_office_id: {
            name: 'Sucursal',
            required: false,
            type: 'AsyncSelectObj',
            endpoint: '/abms/branch_office/Car_lot/',
          },
          location_id: {
            name: 'Ubicación',
            required: true,
            type: 'AsyncSelectObj',
            endpoint: "/abms/location"
          },
          licensee: {
            name: 'Licenciatario',
            required: false,
            disabled:true,
            type: 'text',
            disabledByState: {
              Facturado: true,
            },
          },
          sale_type_id: {
            name: 'Tipo de venta',
            required: false,
            type: 'AsyncSelectObj',
            endpoint: '/saletypes',
            disabledByState: {
              Facturado: true,
            },
          },
          number_keys: {
            name: 'Número de llave',
            required: false,
            type: 'number',
          },
          vin: {
            name: 'VIN',
            type: 'text',
            required: false,
            disabledByState: {
              Facturado: true,
            },
          },
          origen: {
            name: 'País de Origen',
            type: 'AsyncSelectCountries',
            required: false,
            disabledByState: {
              Facturado: true,
            },
          },
        },
        seguimiento: {
          _name: 'Seguimiento',
          estado: {
            name: 'Estado',
            required: true,
            options: [
              {label: ESTADO_STOCK.ACTIVO, disabled: false},
              {label: ESTADO_STOCK.PENDIENTE, disabled: false},
              {label: ESTADO_STOCK.NO_A_LA_VENTA, disabled: false},
              {label: ESTADO_STOCK.PRONTO_EN_STOCK, disabled: true},
              {label: ESTADO_STOCK.RESERVADO, disabled: true}, 
              {label: ESTADO_STOCK.RESERVADO_SV, disabled: true}, 
              {label: ESTADO_STOCK.FACTURADO, disabled: true}], //este array de objetos es dependiente de objectOptions//
            objectOptions: true, //solo utilizable para opciones con formato de array de objetos//
            default: "Pendiente",
            type: 'enum',
            disableConditions: [ESTADO_STOCK.RESERVADO, ESTADO_STOCK.RESERVADO_SV, ESTADO_STOCK.FACTURADO], //Parámetro que se utiliza para condicionar la habilitación del select en schemaProcessing a través de la función isDisabledCondition
            disabledByState: {
              Facturado: true,
            },
          },
          offer_number: {
            name: 'Número de oferta',
            required: false,
            type: 'number',
            disabled: true,
            disabledByState: {
              Facturado: true,
            },
          },
          offer_date: {
            name: 'Fecha de oferta',
            required: false,
            type: 'date',
            dateTo: {
              until: "TODAY"
            },
            disabled: true,
            disabledByState: {
              Facturado: true,
            },
          },
          bill_date: {
            name: 'Fecha de factura',
            required: false,
            type: 'date',
            dateTo: {
              until: "TODAY"
            },
            disabledByState: {
              Facturado: true,
            },
          },
          bill_amount: {
            name: 'Importe de factura',
            required: false,
            type: 'number',
            disabledByState: {
              Facturado: true,
            },
          },
          observaciones: {
            name: 'Observación',
            required: false,
            type: 'textarea',
          },
        }
      },
    },
  },
}
